import React, { useState, useEffect } from 'react';
import { checkSessionHeartbeat, refreshHeartbeat } from '../utils/sessionManager';

interface SessionDebugInfoProps {
  isVisible: boolean;
}

const SessionDebugInfo: React.FC<SessionDebugInfoProps> = ({ isVisible }) => {
  const [heartbeatInfo, setHeartbeatInfo] = useState(checkSessionHeartbeat());
  const [refreshCounter, setRefreshCounter] = useState(0);
  
  useEffect(() => {
    if (!isVisible) return;
    
    const interval = setInterval(() => {
      setHeartbeatInfo(checkSessionHeartbeat());
    }, 1000);
    
    return () => clearInterval(interval);
  }, [isVisible]);
  
  const handleManualRefresh = () => {
    refreshHeartbeat();
    setHeartbeatInfo(checkSessionHeartbeat());
    setRefreshCounter(prev => prev + 1);
  };
  
  if (!isVisible) return null;
  
  return (
    <div className="fixed bottom-4 right-4 p-4 bg-white border border-gray-300 rounded-lg shadow-lg z-50 max-w-md text-xs font-mono">
      <h3 className="font-bold mb-2 text-sm">Session Debug</h3>
      <div className="space-y-1">
        <p>Heartbeat exists: <span className={heartbeatInfo.exists ? "text-green-600" : "text-red-600"}>
          {heartbeatInfo.exists ? "Yes" : "No"}
        </span></p>
        
        <p>Heartbeat valid: <span className={heartbeatInfo.isValid ? "text-green-600" : "text-red-600"}>
          {heartbeatInfo.isValid ? "Yes" : "No"}
        </span></p>
        
        {heartbeatInfo.timestamp && (
          <>
            <p>Last timestamp: {new Date(heartbeatInfo.timestamp).toISOString()}</p>
            <p>Age: {Date.now() - heartbeatInfo.timestamp}ms (expires at {heartbeatInfo.expiryTime}ms)</p>
          </>
        )}
        
        <p>Auth token: <span className={localStorage.getItem('token') ? "text-green-600" : "text-red-600"}>
          {localStorage.getItem('token') ? "Present" : "Missing"}
        </span></p>
        
        <p>User data: <span className={localStorage.getItem('user') ? "text-green-600" : "text-red-600"}>
          {localStorage.getItem('user') ? "Present" : "Missing"}
        </span></p>
        
        <div className="mt-2 pt-2 border-t border-gray-200">
          <button 
            onClick={handleManualRefresh}
            className="px-2 py-1 bg-blue-100 text-blue-800 rounded hover:bg-blue-200"
          >
            Refresh Heartbeat ({refreshCounter})
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionDebugInfo; 